// Client-side demo listings (yacht / truck / motorcycle). The public listings feed
// is an external read-only API that only carries cars, so these showcase fixtures
// let the multi-category filters + the enriched vehicle-detail specs come alive.
// Their ids are prefixed "demo-" and resolved locally by Results + CarDetail.
export const DEMO_LISTINGS = [
  {
    id: "demo-boat-beneteau",
    demo: true,
    make: "Beneteau",
    model: "Gran Turismo 45",
    price: 385000,
    year: 2020,
    mileage: 0,
    fuel: "Diesel",
    transmission: "Automatic",
    power: 870,
    color: "White",
    location: "Zeebrugge",
    city: "Zeebrugge",
    seller_id: null,
    images: [
      "https://images.unsplash.com/photo-1562281302-809108fd533c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
      "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    ],
    options: ["Yacht à moteur", "Planant", "GPS", "Radar", "Pilote automatique", "Guindeau"],
    description:
      "Magnifique yacht à moteur, entretien suivi, prêt à naviguer. Coque impeccable et intérieur soigné.\n\n" +
      "— Caractéristiques Bateau —\n" +
      "Type: Yacht à moteur\n" +
      "Longueur: 13.8 m\n" +
      "Largeur: 4.2 m\n" +
      "Tirant d'eau: 1.1 m\n" +
      "Heures moteur: 320 h\n" +
      "Type de coque: Planant\n" +
      "Équipement: GPS, Radar, Pilote automatique, Guindeau\n\n" +
      "— Motorisation —\n" +
      "Motorisation: 2 × Volvo Penta IPS600\n" +
      "Puissance: 870 ch",
  },
  {
    id: "demo-truck-scania",
    demo: true,
    make: "Scania",
    model: "R 500",
    truck_subtype: "tracteur-routier",
    price: 68000,
    year: 2019,
    mileage: 420000,
    fuel: "Diesel",
    transmission: "Automatic",
    power: 500,
    color: "Blue",
    location: "Anvers",
    city: "Anvers",
    seller_id: null,
    images: [
      "https://images.pexels.com/photos/12159230/pexels-photo-12159230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
      "https://images.unsplash.com/photo-1586206670130-4c6d8e646c9a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    ],
    options: ["Tracteur routier", "4x2", "Cabine couchette", "Frigo", "Régulateur"],
    description:
      "Tracteur routier Scania R 500, cabine haute confort, entretien constructeur, prêt au travail.\n\n" +
      "— Caractéristiques Camion —\n" +
      "Type: Tracteur routier\n" +
      "PTAC: 40 t\n" +
      "Charge utile: 26000 kg\n" +
      "Volume de chargement: 92 m³\n" +
      "Configuration: 4x2\n" +
      "Nombre d'essieux: 2\n" +
      "Type de cabine: Cabine couchette\n\n" +
      "— Motorisation —\n" +
      "Puissance: 500 ch",
  },
  {
    id: "demo-moto-ducati",
    demo: true,
    make: "Ducati",
    model: "Multistrada V4",
    moto_subtype: "trail",
    price: 18900,
    year: 2022,
    mileage: 8500,
    fuel: "Petrol",
    transmission: "Manual",
    power: 170,
    color: "Red",
    location: "Bruxelles",
    city: "Bruxelles",
    seller_id: null,
    images: [
      "https://images.pexels.com/photos/9264626/pexels-photo-9264626.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
      "https://images.unsplash.com/photo-1629294148914-678ba902dd49?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    ],
    options: ["Trail / Adventure", "ABS", "Régulateur de vitesse", "Feux LED"],
    description:
      "Ducati Multistrada V4 en parfait état, carnet d'entretien complet, pneus neufs.\n\n" +
      "— Caractéristiques Moto —\n" +
      "Type: Trail / Adventure\n" +
      "Cylindrée: 1158 cm³\n" +
      "Puissance: 170 ch\n\n" +
      "— Motorisation —\n" +
      "Puissance: 170 ch",
  },
];

export const DEMO_BY_ID = Object.fromEntries(DEMO_LISTINGS.map((d) => [d.id, d]));
